import { getTreemap } from 'treemap-squarify';

// This class handles the drawing, positioning and event listeners for the square blocks for currency strength meter
export class StrengthMeterSquares {
  constructor(args, popupManager) {
    for (const key in args) {
      this[key] = args[key];
    }
    this.strengthMeterHoverController = popupManager;

    this.children = this.createChildren(this.children);
    this.totalValue = this.calculateTotalValue(this);
    this.sortChildren(this);

    // Class method binding
    this.createPositioning = this.createPositioning.bind(this);
    this.drawElements = this.drawElements.bind(this);
    this.addListeners = this.addListeners.bind(this);
    this.addHoverListeners = this.addHoverListeners.bind(this);
    this.getChildrenData = this.getChildrenData.bind(this);
    this.createChildren = this.createChildren.bind(this);
    this.calculateTotalValue = this.calculateTotalValue.bind(this);
    this.sortChildren = this.sortChildren.bind(this);
  }

  createPositioning(width, height) {
    const valuesData = [];
    if (this.children) {
      for (let i = 0; i < this.children.length; i++) {
        const child = this.children[i];
        const childData = {
          value: child.totalValue,
          name: child.name,
        };
        if (childData.value) {
          valuesData.push(childData);
        }
      }
    }
    width = width || 1;
    height = height || 1;
    if (valuesData.length > 0) {
      this.positionsData = getTreemap({
        data: valuesData,
        width: width, // the width and height of your treemap
        height: height,
      });
    }
  }
  drawElements(parentDiv) {
    if (!parentDiv) {
      return;
    }
    const width = parentDiv.offsetWidth - this.margin;
    const height = parentDiv.offsetHeight - this.margin;
    this.createPositioning(width, height);

    const wrapperDiv = document.createElement('DIV');
    wrapperDiv.classList.add('children_wrapper');
    wrapperDiv.style.width = `${width}px`;
    wrapperDiv.style.height = `${height}px`;
    if (this.children) {
      for (let i = 0; i < this.children.length; i++) {
        if (!this.positionsData) {
          break;
        }
        if (this.positionsData[i]) {
          const childPosition = this.positionsData[i];
          const childDiv = document.createElement('DIV');
          childDiv.classList.add('child-div');
          childDiv.style.left = `${childPosition.x + this.margin}px`;
          childDiv.style.top = `${childPosition.y + +this.margin}px`;
          childDiv.style.width = `${childPosition.width - 1}px`;
          childDiv.style.height = `${childPosition.height - 1}px`;
          // childDiv.style.padding = this.margin + 'px';
          // childDiv.style.paddingBottom = this.margin + 'px';
          // childDiv.style.paddingRight = this.margin + 'px';

          const listCssWrapper = this.children[i].cssClass;
          const listCssClassesWrapper = this.children[i].cssClassWrapper;
          for (const ind in listCssWrapper) {
            childDiv.classList.add(listCssWrapper[ind]);
          }
          for (const ind in listCssClassesWrapper) {
            wrapperDiv.classList.add(listCssClassesWrapper[ind]);
          }
          wrapperDiv.append(childDiv);
          this.children[i].initialDiv = childDiv;
        }
      }
    }
    const blockNameDiv = document.createElement('DIV');
    blockNameDiv.classList.add('block-name');
    blockNameDiv.innerHTML = this['name'];
    blockNameDiv.style.fontSize = `${Math.sqrt(width * height) * 0.11}px`;
    parentDiv.append(wrapperDiv);
    parentDiv.append(blockNameDiv);
    this.overallDiv = parentDiv;
    this.addListeners();

    if (this.children) {
      for (let i = 0; i < this.children.length; i++) {
        this.children[i].drawElements(this.children[i].initialDiv);
      }
    }
  }

  addListeners() {
    if (this.fillPopup) {
      this.addHoverListeners('fill');
    }
    if (this.sortPopup) {
      this.addHoverListeners('sort');
    }
  }

  addHoverListeners(typeAction) {
    if (typeAction == 'fill') {
      this.overallDiv.addEventListener('mouseenter', () => {
        this.strengthMeterHoverController.fillPopup(this);
      });
    } else if (typeAction == 'sort') {
      this.overallDiv.addEventListener('mouseenter', () => {
        this.strengthMeterHoverController.sortPopup(this);
      });
    }
  }

  getChildrenData() {
    let result = [];
    if (this.pairName) {
      const element = {
        pairName: this.pairName,
        timeFrame: this.timeFrame,
        pairChange: this.value,
        pairRate: this.pairRate,
      };
      result.push(element);
    }

    if (this.children) {
      for (const i in this.children) {
        result = result.concat(this.children[i].getChildrenData());
      }
    }

    result.sort(function compareNumbers(a, b) {
      return b.pairChange - a.pairChange;
    });

    return result;
  }

  createChildren(children) {
    const result = [];
    if (children) {
      for (let i = 0; i < children.length; i++) {
        const args = {
          name: children[i]['name'],
          cssClass: children[i]['cssClass'],
          children: children[i].children,
          margin: children[i].margin,
          value: children[i].value,
          cssClassWrapper: children[i].cssClassWrapper,
          fillPopup: children[i].fillPopup,
          sortPopup: children[i].sortPopup,
          pairName: children[i].pairName,
          timeFrame: children[i].timeFrame,
          pairRate: children[i].pairRate,
        };
        const child = new StrengthMeterSquares(
          args,
          this.strengthMeterHoverController
        );
        result.push(child);
      }
    }
    return result;
  }

  calculateTotalValue(squareBlock) {
    let result = 0;
    if (squareBlock.value) {
      result = result + Math.abs(squareBlock.value);
    }
    if (squareBlock.children) {
      for (let i = 0; i < squareBlock.children.length; i++) {
        result = result + this.calculateTotalValue(squareBlock.children[i]);
      }
    }

    return result;
  }

  sortChildren(squareBlock, realValue) {
    if (squareBlock.children) {
      squareBlock.children.sort(function compareNumbers(a, b) {
        if (realValue) {
          return b.totalValueReal - a.totalValueReal;
        } else {
          return b.totalValue - a.totalValue;
        }
      });
      for (const i in squareBlock.children) {
        this.sortChildren(squareBlock.children[i], realValue);
      }
    }
  }
}
